import React, { Component } from 'react';
import { GeckoCard, Spinner } from '../../components';
import { Auth, ClientManager } from '../../services';
import { $stateParams } from '../../router';

export class HoldingPage extends Component {
    componentDidMount() {
        const return_url = ClientManager.returnUrl();
        ClientManager.clear();

        // Mobile apps have an issue where their web views are staying logged in.
        // so we should log out of cognito at this point so a Web View reload
        // would let the app begin the authentication process again.
        Auth.destroy(true).catch((err) => {
            console.error('Error during logout:', err);
        }).finally(() => {
            if (return_url) {
                window.location = `${return_url}?code=${$stateParams.code}`
            }
        })
    }

    render() {
        return (
            <GeckoCard>
                <div className="row text mt-3 mb-3">
                    <div className="col d-flex flex-column align-items-center">
                        <Spinner size="small" />
                    </div>
                </div>
            </GeckoCard>
        );
    }
}

export default HoldingPage;
